<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19DZhLg/tc-custom/9781618683236.jpg?1726617359155" alt="This image is the cover for the book Journal: Cracked Earth, The Journal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Journal: Cracked Earth, The Journal Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A shocking natural disaster rocks the country. And only one woman is prepared to handle the fallout. A post-apocalyptic thriller series begins.</b><br/><br/><b>When a major crisis rocks the nation, supply lines are shut down everywhere. </b><br/><br/><b>The small town of Moose Creek feels the effects almost immediately as they begin to run out of food.</b><br/><br/><b>In the remote regions of the Upper Peninsula of Michigan, the residents are hit again when the power is cut off to them in the middle of a brutal winter and they must struggle with one calamity after another, with the help of one woman</b><br/><br/><b>Allexa Smeth is their under-trained Emergency Manager, with problems of her own.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah D. Moore
      </h2>
      
      <p class="authorDescription body article">Deborah Moore lives a quiet life in the Upper Peninsula of Michigan with her cat, Tufts.  She was born and raised in Detroit, the kid of a cop, moved to a small town to raise her two young sons, then moved to an even smaller town to pursue her dreams of being self-sufficient and to explore her love of writing.  Being a life-long Prepper, Deborah has done numerous articles for magazines and speaking engagements on the subject.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Permuted Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3159ea3a